import { Box, TextField, Typography } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import useAPI from "../../../../../../api/hooks/useAPI";
import useColors from "../../../../../../api/hooks/useColors";
import { notificationSettingsKeys } from "../../../../../../api/queryKeys";
import ContainedButton from "../../../../../../components/buttons/ContainedButton";
import { Toast } from "../../../../../../components/Toast";
import { isEmailValid } from "../../../../../../utils/utils";
import { notificationMethod } from "../../../../constants";
import { field_IDs_mapping } from "../../../fieldMapping";

export default function InventoryDriftEmailTextBox({
  initialEmail,
  initialDriftByTool,
}) {
  const colors = useColors();
  const { updateNotificationSetting } = useAPI();
  const [email, setEmail] = useState(initialEmail);
  const queryClient = useQueryClient();

  const emailSaveMutation = useMutation({
    mutationFn: () =>
      updateNotificationSetting(
        notificationMethod.EMAIL,
        field_IDs_mapping.INVENTORY.ENTITIES_DRIFT,
        {
          email: email,
          drift_percentage_by_tool: initialDriftByTool,
        }
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: notificationSettingsKeys.all,
      });
      Toast.success("Email saved successfully");
    },
    onError: () => {
      Toast.error("Error saving email");
    },
  });

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant="body2">Destination email</Typography>
      <Box display="flex" flexDirection="row" gap={1} alignItems="center">
        <TextField
          id="inventory-drift-email"
          placeholder="Enter email address"
          value={email}
          fullWidth
          onChange={(event) => {
            setEmail(event.target.value);
          }}
          sx={{
            width: "100%",
            maxWidth: "300px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "6px",
              height: "30px",
              "& .MuiInputBase-input": {
                height: "36px",
                padding: "0 14px",
              },
            },
            "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: colors.grey_400,
              borderWidth: "1px",
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                borderColor: colors.grey_400,
                borderWidth: "1px",
              },
          }}
          InputProps={{
            style: {
              fontSize: "0.875rem",
            },
          }}
        />
        <ContainedButton
          color="primary"
          size="xs"
          onClick={() => {
            emailSaveMutation.mutate();
          }}
          disabled={email === initialEmail || !isEmailValid(email)}
          loading={emailSaveMutation.isPending}
        >
          Save
        </ContainedButton>
      </Box>
    </Box>
  );
}
